const body = document.querySelector( 'body' );
const header = document.querySelector( 'header' );

function handleScrollResizeLoad() {
  if( !body.classList.contains( 'transparent-header' ) ) {
    return;
  }
  const scroll = window.scrollY || document.documentElement.scrollTop;
  if ( scroll >= 120 ) {
    header.classList.remove( 'transparent-header' );
  } else {
    header.classList.add( 'transparent-header' );
  }
}

function addHeaderClass() {
  if ( body.classList.contains( 'transparent-header' ) ) {
    header.classList.add( 'transparent-header' );
  } else {
    body.classList.remove( 'transparent-header' );
  }
}

['load',].forEach( ( event ) => {
  window.addEventListener( event, addHeaderClass );
} );
['load', 'scroll', 'resize'].forEach( ( event ) => {
  window.addEventListener( event, handleScrollResizeLoad );
} );
